export default "__VITE_ASSET__NLDkGDAG__"